import { when } from '@execonline-inc/maybe-adapter';
import { Menu } from '@headlessui/react';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import Dropdown from './Dropdown';
import FilterButtonText from './FilterButtonText';
import CompetencyFilterStore from './Store';
import { CompetencyFilterOptions } from './Types';

interface Props {
  competencyFilterStore: CompetencyFilterStore;
  options: CompetencyFilterOptions[];
}

const CompetencyFilter: React.FC<Props> = ({ competencyFilterStore, options }) => (
  <div className="flex md:flex-row">
    <div className="mr-3">
      <Menu as="div">
        {({ open }) => (
          <>
            <Menu.Button
              onClick={() =>
                when(open, {})
                  .do(() => competencyFilterStore.close())
                  .elseDo(() => competencyFilterStore.open())
              }
              className={clsx(
                'mt-1 block w-48 rounded-md border-1 border-solid',
                'border-gray-300 bg-white px-3 py-2 text-sm font-medium',
              )}
            >
              <FilterButtonText competencyFilterStore={competencyFilterStore} />
            </Menu.Button>
            {when(open, {})
              .map(() => (
                <Dropdown competencyFilterStore={competencyFilterStore} options={options} />
              ))
              .getOrElse(() => (
                <></>
              ))}
          </>
        )}
      </Menu>
    </div>
  </div>
);

export default observer(CompetencyFilter);
